module.exports = __webpack_public_path__ + "img/indexBg.a607ccf9.jpg";